import httpClient from '@/global/httpClient';
import * as apis from '@/constants/api';

export const getPlvWatchLink = ({ channelId, invitePosterId }) =>
  httpClient.get(apis.getPlvWatchLink(channelId), {
    params: { invitePosterId },
  });
